import EndUserLicenseAgreementPath from './LicenseAgreement/GdsEndUserLicenseAgreement.txt'

const ProductDownloadInfosErrorText = 'Failed to retrieve assemblies, programming guides and sample codes';

function isValidResponse(responseTextLower) {
    return (responseTextLower !== ProductDownloadFunctions.NaString &&
            responseTextLower !== ProductDownloadFunctions.NullString &&
            responseTextLower.length > 0);
}

function readEndUserLicenseAgreement() {
    const readLicenseAgreementRequest = new XMLHttpRequest();

    readLicenseAgreementRequest.onreadystatechange = function () {
        if (readLicenseAgreementRequest.readyState === 4 && readLicenseAgreementRequest.status === 200) {
            if (readLicenseAgreementRequest.responseText != null) {
                ProductDownloadFunctions.EndUserLicenseAgreementTexts = readLicenseAgreementRequest.responseText.split('\n');
            }
        }
    }

    readLicenseAgreementRequest.open('GET', EndUserLicenseAgreementPath);
    readLicenseAgreementRequest.send();
}

function getProductDownloadInfoCollection(productEditions) {
    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
            let responseTextLower = this.responseText.toLowerCase();
            if (isValidResponse(responseTextLower)) {
                let allProductDownloadInfos = JSON.parse(this.responseText);

                let productDownloadInfos = [];
                allProductDownloadInfos.forEach(productDownloadInfo => {
                    if (productEditions.includes(productDownloadInfo.productEdition)) {
                        productDownloadInfos.push(productDownloadInfo);
                    }
                });

                ProductDownloadFunctions.setProductDownloadInfos(productDownloadInfos);
            }
            else {
                ProductDownloadFunctions.setProductDownloadInfosError(ProductDownloadInfosErrorText);
            }
        }
    };

    let url = ProductDownloadFunctions.ServerUrl + 'GetProductDownloadInfoCollection';

    xhttp.open("POST", url, true);
    xhttp.send();
}

function download(productEdition, downloadType, downloadPosition, fileName) {
    if (productEdition <= 0 || downloadType < 0 || downloadPosition < 0 || fileName.length < 10) {
        return;
    }

    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
            var blob = new Blob([this.response], { type: 'application/octet-stream' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        }
    };

    let url = ProductDownloadFunctions.ServerUrl + 'Download';

    xhttp.open("POST", url, true);
    xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhttp.responseType = 'blob';

    let reqObj = {
        ProductEdition: productEdition,
        DownloadType: downloadType,
        DownloadPosition: downloadPosition
    };

    xhttp.send(JSON.stringify(reqObj));
}

function getProductName(productEdition) {
    switch (productEdition) {
        case ProductDownloadFunctions.ProductEditionGdsGoogleMapsWinForms:
            return "GDS Google Maps WinForms";
        case ProductDownloadFunctions.ProductEditionGdsGoogleMapsWpf:
            return "GDS Google Maps WPF";
        case ProductDownloadFunctions.ProductEditionGdsEasyMq:
            return "GDS Easy MQ";
        default:
            return "";
    }
}

const ProductDownloadFunctions = {
    NaString: 'n/a',
    NullString: 'null',

    ProductEditionGdsGoogleMapsWinForms: 1,
    ProductEditionGdsGoogleMapsWpf: 2,
    ProductEditionGdsEasyMq: 3,

    DownloadTypeAssembly: 0,
    DownloadTypeGuide: 1,
    DownloadTypeSample: 2,

    EndUserLicenseAgreementTexts: [],
    FileNameToDownload: '',
    ProductGuideSamples: [],

    ServerUrl: window.location.href + 'api/Service/',

    readEndUserLicenseAgreement: readEndUserLicenseAgreement,

    getProductDownloadInfoCollection: getProductDownloadInfoCollection,
    download: download,

    getProductName: getProductName,

    getProductDownloadInfos: function () {},
    setProductDownloadInfos: function() {},

    setProductDownloadInfosError: function() {}
}

export default ProductDownloadFunctions;
